module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_privacy_m_jp.1a8cd17abd333c433394cb5c17da8247.png";